export default __webpack_public_path__ + "static/media/christine.22317d20.jpeg";